import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { T as Text } from './Text-BCmEgJBp.js';
import { G as Glimmer } from './Glimmer-C-gTChiy.js';
import { S as Spinner } from './Spinner---cbFcCd.js';
import { A as AnimatedPresence } from './AnimatedPresence-CCuDxPC9.js';
import { C as ComboboxOption } from './ComboboxOption-4NlS0P16.js';
import { C as ComboboxLoadMore } from './ComboboxLoadMore-DyA2Imtj.js';

var styles = {"container":"SgMzjOcdE-E-","optionsList":"TwoTCjgcssc-","filterMessage":"_8T5M7MGwCRE-","emptyStateMessage":"_4y5NXkNeIQM-","scrollTop":"T6E3VwBGoQM-","scrollNone":"_6HQzxMQkXnE-","scrollBottom":"_5YsJZyMDkbA-","loadingContainer":"A6z4OI58xoE-","hasOptions":"QqHBSf52fPk-"};

function ComboboxContentList(props) {
    const optionsExist = props.options.length > 0;
    const hasSearchTerm = props.searchValue.length > 0;
    const { listScrollState } = useScrollState(props.optionsListRef, props.options);
    return (React.createElement("div", { className: classnames(styles.container, styles[listScrollState]) },
        optionsExist && (React.createElement("ul", { className: styles.optionsList, role: "listbox", "aria-multiselectable": props.multiselect, ref: props.optionsListRef },
            props.options.map(option => {
                return (React.createElement(ComboboxOption, { key: option.id, id: option.id, label: option.label, prefix: option.prefix }));
            }),
            React.createElement("div", { className: classnames([styles.loadingContainer, styles.hasOptions]) },
                React.createElement(AnimatedPresence, { transition: "fromBottom" }, Boolean(props.loading && optionsExist) && (React.createElement(Spinner, { size: "small" })))),
            props.onLoadMore && (React.createElement(ComboboxLoadMore, { onLoadMore: props.onLoadMore })))),
        props.loading && !optionsExist && (React.createElement(React.Fragment, null, Array.from({ length: 5 }).map((_, index) => (React.createElement("div", { className: styles.loadingContainer, key: index },
            React.createElement(Glimmer, { shape: "rectangle", size: "small" })))))),
        hasSearchTerm && !props.loading && !optionsExist && (React.createElement("div", { className: styles.filterMessage },
            React.createElement(Text, { variation: "subdued" },
                "No results for ",
                `“${props.searchValue}”`))),
        !hasSearchTerm && !props.loading && !optionsExist && (React.createElement("div", { className: styles.emptyStateMessage },
            React.createElement(Text, { variation: "subdued" }, getZeroIndexStateText(props.subjectNoun))))));
}
function getZeroIndexStateText(subjectNoun) {
    if (subjectNoun) {
        return `You don't have any ${subjectNoun} yet`;
    }
    return "No options yet";
}
function useScrollState(optionsListRef, options) {
    const [listScrollState, setlistScrollState] = useState("");
    useEffect(() => {
        const handleScroll = () => {
            if (optionsListRef.current) {
                const { scrollTop, clientHeight, scrollHeight } = optionsListRef.current;
                if (scrollHeight === clientHeight) {
                    setlistScrollState("scrollNone");
                }
                else if (scrollTop === 0) {
                    setlistScrollState("scrollTop");
                }
                else if (scrollTop + clientHeight >= scrollHeight) {
                    setlistScrollState("scrollBottom");
                }
                else {
                    setlistScrollState("");
                }
            }
        };
        if (options.length === 0) {
            handleScroll();
        }
        if (optionsListRef.current) {
            optionsListRef.current.addEventListener("scroll", handleScroll);
            handleScroll();
        }
        return () => {
            if (optionsListRef.current) {
                optionsListRef.current.removeEventListener("scroll", handleScroll);
            }
        };
    }, [options]);
    return { listScrollState };
}

export { ComboboxContentList as C };
